import {memo} from "react";

export const Title = memo(({children}) => {
    return (
        <>
            {children}
        </>
    )
})